import React from "react";
import "./style.css";
import "animate.css";

function About() {
  return (
    <section className="bg-gray-100 py-16 px-6 animate__animated animate__fadeIn mt-10">
      <div className="max-w-5xl mx-auto bg-white rounded-2xl shadow-xl p-4 md:p-12 mt-6 sm:mt-10 md:mt-20">
        {/* Заголовок */}
        <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6 leading-snug -mt-4">
          AJAR MEBELге кош келиңиздер!
          <span className="block text-[#2A254B] mt-2">«AJAR MEBEL»</span>
        </h2>

        {/* Описание */}
        <p className="text-lg text-gray-700 mb-6 leading-relaxed">
          Биз <strong>15 жылдык тажрыйбага</strong> ээ болгон компаниябыз жана
          өз өндүрүшүбүздөн түздөн-түз жогорку сапаттагы мебелди сунуштайбыз.
        </p>

        <div className="bg-gray-50 border-l-4 border-[#2A254B] p-4 rounded-md mb-8">
          <p className="text-lg font-medium text-gray-800">
            Бардык эмерекке <span className="font-bold">1 жылдык</span>{" "}
            кепилдик!
          </p>
        </div>

        {/* Преимущества */}
        <h3 className="text-2xl font-semibold text-gray-800 mb-4">
          Биздин артыкчылыктар
        </h3>

        <ul className="grid gap-4 text-gray-700">
          <li className="flex gap-3">
            <span className="text-[#2A254B] text-xl">✔</span>
            <span>
              <strong>Түз жеткирүү:</strong> цехтен түз чыгарылган стол жана
              стулдар — сапат жана уникалдуу дизайн.
            </span>
          </li>

          <li className="flex gap-3">
            <span className="text-[#2A254B] text-xl">✔</span>
            <span>
              <strong>Кепилденген сапат:</strong> мыкты материалдар жана
              тажрыйбалуу усталар.
            </span>
          </li>

          <li className="flex gap-3">
            <span className="text-[#2A254B] text-xl">✔</span>
            <span>
              <strong>Оптовый баалар:</strong> дүң жана чекене кардарлар үчүн
              пайдалуу сунуштар.
            </span>
          </li>

          <li className="flex gap-3">
            <span className="text-[#2A254B] text-xl">✔</span>
            <span>
              <strong>Кыргызстан боюнча жеткирүү:</strong> ыкчам, ишенимдүү жана
              коопсуз.
            </span>
          </li>
        </ul>
        <div
          className="
              bg-gray-50 rounded-2xl p-4 md:p-4 
              border border-gray-200 shadow-inner mt-10
            "
        >
          <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6">
            AJAR MEBEL — эки даректе!
          </h3>

          <ul className="space-y-6 text-lg md:text-xl text-gray-800">
            <li className="flex items-start gap-4">
              <span className="text-[#A1C349] text-2xl">•</span>
              <div>
                <strong>Бишкек, Кулатова көч. 2</strong>
                <br />
                «Стройпак» СБ, 3-кабат
              </div>
            </li>
            <li className="flex items-start gap-4">
              <span className="text-[#A1C349] text-2xl">•</span>
              <div>
                <strong>Беш-Сары СБ</strong>
                <br />
                (Ош базары, 1-кабат)
              </div>
            </li>
          </ul>

          <p className="mt-8 text-lg md:text-xl text-gray-700 font-medium">
            Эмеректерди дүкөндөн көрүп, тандап алыңыз — сапат, стиль жана
            ыңгайлуулук.
            <br />
            <span className="font-semibold text-gray-900">
              Биз сизге туура тандоодо ар дайым жардам беребиз.
            </span>
          </p>
        </div>
      </div>
    </section>
  );
}

export default About;
